import React from 'react';

class CacheInfo extends React.Component {

    static propTypes = {
        cachedTime: React.PropTypes.string,
        cacheEntities: React.PropTypes.string,
        entityId: React.PropTypes.string,
        reloadWithForceRefresh: React.PropTypes.bool
    };

    constructor(props) {
        super(props);
    }    

  render() {
      const { cachedTime, cacheEntities, entityId, reloadWithForceRefresh } = this.props;

      const buildReloadUrl = () => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('forceRefresh', '1');
        return currentUrl.toString();
      };
      
      const handleClearCache = () => {
        $.ajax({
          url: `/api/publicApi/ClearCache?entityId=${encodeURIComponent(entityId)}`,
          method: 'POST',
          contentType: 'application/json; charset=utf-8',
          data: JSON.stringify(cacheEntities)
        }).done(() => {
          if (reloadWithForceRefresh) {
            window.location.assign(buildReloadUrl());
            return;
          }

          location.reload();
        });
      } 

      return (
        <div className='cache-info'>
          <span>{`Data aktuální k: ${moment(cachedTime).format('DD.MM.YYYY HH:mm')}`}</span>
          <a href={'javascript:void(0)'} onClick={handleClearCache} className={"cache-refresh"}>
            <i className={"material-icons"}>{'refresh'}</i>
          </a>
        </div>
      )
  }
}

export default CacheInfo;



// WEBPACK FOOTER //
// ./App/components/cacheInfo.js